module.exports = __webpack_public_path__ + "img/cgzs.b9390365.png";